/**
 * Box-supplier values that select a shore-power provider flow.
 *
 * The literal "Holland Amerika Kade" must match the backend constant
 * ShorePowerDetails.HOLLAND_AMERIKA_KADE_BOX_SUPPLIER exactly; it is the single
 * trigger that switches the UI from the ITransact section to the provider-less
 * Holland Amerikakade section.
 */
export const ITRANSACT_BOX_SUPPLIER = 'ITransact';
export const HOLLAND_AMERIKA_KADE_BOX_SUPPLIER = 'Holland Amerika Kade';
